import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, Modal, notification, } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { ThemeContext } from '../../../theme/ThemeContext'
import { RootDispatch } from '../../../app/store'
import { DateRangeType, getDateRange } from '../../../compnents/form/DateSelect'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import {
  exportPrescriptionQueryListAsync,
  getPrescriptionDetailAsync,
  getPrescriptionQueryListAsync,
  setCurrentTab,
  setTreatmentId,
} from '../PharmacyRetailSlice'
import { getTreatmentDetail } from '../../patient/patientSlice'
import { setRecipeEditorTreatment } from '../../treatment/editor/recipeListEditorSlice'
import styles from './PrescriptionQueryList.module.css'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { AGColumns } from './column'
import { getSortColumnList } from '../../../models/common'
import { Query } from './Query'
import { PrescriptionDetailModal } from './PrescriptionDetailModal'


const PrescriptionQueryList = (props: {
  currentTab?: any
  goBackParams?: (v: any) => void
  onReapply?: () => void
}): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [visible, setVisible] = useState(false)

  const [selectedRow, setSelectedRow] = useState<any>()

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '处方单号',
      field: 'prescriptionNo',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 130,
      minWidth: 130,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },

    {
      headerName: '处方类型',
      field: 'recipeCategory',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '处方来源',
      field: 'prescriptionSource',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '处方状态',
      field: 'status',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '不通过原因',
      field: 'reason',
      minWidth: 180,
      visible: true,
    },
    {
      headerName: '结算状态',
      field: 'settlementStatus',
      minWidth: 170,
      visible: true,
    },
    {
      headerName: '疾病名称',
      field: 'disease',
      minWidth: 180,
      visible: true,
    },
    // {
    //   headerName: '开单医生',
    //   field: 'prescribeDoctor',
    //   minWidth: 120,
    //   visible: true,
    // },
    // {
    //   headerName: '主管科室',
    //   field: 'departmentName',
    //   minWidth: 120,
    //   visible: true,
    // },
    {
      headerName: '开单时间',
      field: 'prescribeTime',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 150,
      minWidth: 150,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  useEffect(() => {
    setAllColumnList(allData)
  }, [])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'prescriptionQueryListPage',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'prescriptionQueryListPage',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据

        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (params?.prescribeTimeStart) {
      setPageLoading(true)
      getPage()
      getPageColumnList()
    }
  }, [params])

  const getPage = () => {
    const queryParams = Object.keys(params).reduce((acc: any, key: string) => {
      const val = params[key]
      if (val !== '' && val !== undefined && val !== null) {
        acc[key] = val
      }
      return acc
    }, {})
    dispatch(getPrescriptionQueryListAsync(queryParams))
      .then(unwrapResult)
      .then((v: any) => {
        setPage({
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  // 打印处方笺 PDF（base64），打开新窗口展示 PDF
  const printBase64Pdf = (base64: string) => {
    if (!base64) {
      message.warning('未获取到处方笺 PDF')
      return
    }
    const newWindow = window.open('', '_blank')
    if (!newWindow) {
      message.warning('浏览器拦截了新窗口，请允许弹出窗口后重试')
      return
    }
    newWindow.document.write(
      `<iframe src="data:application/pdf;base64,${base64}" style="width:100%;height:100%;border:none;"></iframe>`
    )
    newWindow.document.close()
  }

  // 导出
  const outCluedExport = () => {
    setExportLoading(true)
    const queryParams = Object.keys(params).reduce((acc: any, key: string) => {
      const val = params[key]
      if (val !== '' && val !== undefined && val !== null) {
        acc[key] = val
      }
      return acc
    }, {})
    dispatch(exportPrescriptionQueryListAsync({ ...queryParams }))
      .then(unwrapResult)
      .then((res: any) => {
        const blob = new Blob([res])
        const fileName = '处方查询.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch(() => {
        notification.error({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <>
      <Col
        style={{ backgroundColor: theme.pn }}
        className={styles.container}
      >
        <Query
          loading={pageLoading}
          exportLoading={exportLoading}
          onValueChange={(v: any) => {
            const paramData = {
              ...params,
              ...v,
              prescribeTimeStart: v?.timeHead && moment(v?.timeHead).isValid()
                ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
              prescribeTimeEnd: v?.timeTail && moment(v?.timeTail).isValid()
                ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
              timeHead: undefined,
              timeTail: undefined,
              current: 1,
            }
            setParams({
              ...paramData,
            })
          }}
          exportExcel={() => outCluedExport()}
          filterColumn={allColumnList} //筛选列
          filterSelectList={filterSelectList}
          // 筛选列变化时的数据
          submitPageList={(v: any) => {
            setPageLoading(true)
            submitPageList(v)
            setAllColumnList(v)
          }}
        />
        <div
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <SimpleAgGrid
            rowHeight={41}
            page={page}
            column={(AGColumns(
              page?.size * (page?.current - 1),
              (action, t,) => {
                switch (action) {
                  case 'detail':
                    setSelectedRow(t)
                    setVisible(true)
                    break
                  case 'print':
                    printBase64Pdf(t?.base64PdfStr)
                    break
                  case 'reapply':
                    // 重新申请：像收费明细双击一样，回填患者/就诊/处方信息到药店开单
                    props?.onReapply?.()
                    dispatch(getPrescriptionDetailAsync({ recipeId: t?.recipeId }))
                      .then(unwrapResult)
                      .then((detail: any) => {
                        const treatmentId = detail?.order?.treatmentId || detail?.treatment?.id
                        if (!treatmentId) {
                          return
                        }
                        dispatch(setTreatmentId(treatmentId))
                        dispatch(getTreatmentDetail(treatmentId))
                          .then(unwrapResult)
                          .then((res: any) => {
                            const obj = JSON.parse(localStorage.getItem('localObj') || '{}')
                            const objs = {
                              ...obj,
                              patientName: detail?.order?.patientName,
                              name: detail?.order?.name,
                              ageYear: res?.patient?.ageYear > -1 ? res?.patient?.ageYear : '',
                              ageMonth: res?.patient?.ageMonth > -1 ? res?.patient?.ageMonth : '',
                              birthday: detail?.order?.patientBirthday,
                              patientSex: Number(detail?.order?.sex),
                              phone: detail?.order?.phone,
                              state: 1,
                              patientId: detail?.order?.patientId,
                              treatmentNo: detail?.treatment?.id,
                              registrationId: detail?.treatment?.registrationId,
                              disease: detail?.treatment?.disease,
                              treatmentDepartmentId: detail?.treatment?.treatmentDepartmentId?.toString(),
                              treatmentDepartmentName: detail?.treatment?.treatmentDepartmentName,
                              treatmentDoctorId: detail?.treatment?.treatmentDoctorId && detail?.treatment?.treatmentDoctorId !== 0 ? detail?.treatment?.treatmentDoctorId : '',
                              treatmentDoctorName: detail?.treatment?.treatmentDoctorName,
                              insuranceCode: detail?.treatment?.insuranceCode,
                              treatmentId: detail?.treatment?.id,
                              ybPersonalNo: detail?.order?.ybPersonalNo,
                              dnzhye: detail?.order?.dnzhye,
                              lnzhye: detail?.order?.lnzhye,
                              companyName: detail?.order?.companyName,
                              insuranceRegion: detail?.order?.insuranceRegion,
                              memberTypeStr: detail?.order?.memberTypeStr,
                              patientInsurance: { ...detail?.order?.patientInsurance },
                            }
                            dispatch(setRecipeEditorTreatment(res?.treatment))
                            props?.goBackParams && props?.goBackParams({ ...objs })
                            localStorage.setItem('localObj', JSON.stringify(objs))
                            // 切回药店开单 tab
                            dispatch(setCurrentTab('0'))
                          })
                      })
                      .catch(() => {
                        // message.error('获取处方信息失败')
                      })
                    break
                }
              },
              allColumnList,
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoading}
            pagination={true}
            pageKey={'prescriptionQueryListPage'}
            rowSelection="multiple"
            suppressRowClickSelection={true}
            onChangePage={(current, size) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
            onColumnResized={(v) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
        </div>
      </Col>
      <PrescriptionDetailModal
        visible={visible}
        recipeId={selectedRow?.recipeId}
        onCancel={() => setVisible(false)}
      />
    </>

  )
}

export const PrescriptionQueryLists = forwardRef(PrescriptionQueryList)
